import { eventsSender } from 'globalState/global-state.js';

export const clickNavButton = ({ source }) => {
    try {
        eventsSender('interface', 'clickNavButton', {
            source,
        });
    } catch (err) {
        console.error(err);
    }
};

export const ourSectionSelect = ({ source }) => {
    try {
        eventsSender('interface', 'ourSectionSelect', {
            source,
        });
    } catch (err) {
        console.error(err);
    }
};
